import { ViewCategory, VisibilityType } from '@ddt-web/config';
import { ComponentVisibility, ConditionalTransformWrapper, FilterEmptyOrZeroColumnTransform, FilterSpecificAssetClassTransform, HasAllDataMissingInAllPortfolios, HasSpecificAssetClass, HideTabTransform, IsNotSpecificValue, ReplaceCellValueConditionTransform, TabDisplayConfig, TabDisplayConfigOptions, VisibilityConfigUtils } from '@ddt-web/data-service';

import * as Config from '../tab-configs';

const FAMILIES_VISIBILITY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.families',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.PUBLIC_VIEW, VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'family.list': {
			default: {
				config: Config.FAMILIES_CONFIG,
				rule: TabDisplayConfig.create({ showInPublicView: true })
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const MODELS_OVERVIEW_VISIBILITY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.models.overview',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.PUBLIC_VIEW, VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'overview': {
			default: {
				config: Config.FAMILY_OVERVIEW_CONFIG,
				rule: new TabDisplayConfig()
			}
		},
		'model.list': {
			default: {
				config: Config.MODEL_LIST_CONFIG,
				rule: TabDisplayConfig.create({ showInPublicView: true })
			}
		},
		'overview.custom.net.return': {
			default: {
				config: Config.FAMILY_OVERVIEW_CUSTOM_NET_RETURN_CONFIG,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const MODELS_MINI_COMPARE_VISIBILITY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.mini.compare',
	visible: { [VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true },
	tabs: {
		'mini.compare.data': {
			default: {
				config: Config.MINI_COMPARE_DATA_CONFIG,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const MODELS_SLIDER_VISIBILITY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.models.slider',
	visible: { [VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true },
	tabs: {
		'models': {
			default: {
				config: Config.MODELS_SLIDER_CONFIG,
				rule: new TabDisplayConfig()
			}
		},
		'estimatedRisks': {
			default: {
				config: Config.MODELS_OVERVIEW_CONFIG,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const FAMILIES_LIST_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.dropdown.families',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'me.dropdown.family.list': {
			default: {
				config: Config.FAMILIES_NAME_CONFIG,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const HOLDING_CHART_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.holdings.chart',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'holdings.chart': {
			default: {
				config: Config.MODEL_HOLDINGS_CHART,
				rule: TabDisplayConfig.create({
					transpose: true
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.MODEL_HOLDINGS_COLUMN_CONFIG]
});

const FAMILY_LATEST_HOLDINGS_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.latestHoldings',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'latestHoldings.header': {
			default: {
				config: Config.FAMILY_LATEST_HOLDINGS_HEADER,
				rule: new TabDisplayConfig()
			}
		},
		'latestHoldings': {
			default: {
				config: Config.FAMILY_LATEST_HOLDINGS_TABLE_BODY,
				rule: TabDisplayConfig.create({
					transpose: true,
					conditions: [new FilterEmptyOrZeroColumnTransform()]
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const FAMILY_CHANGES_TO_HOLDINGS_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.changesToHoldings',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'changesToHoldings': {
			default: {
				config: Config.FAMILY_CHANGES_TO_HOLDINGS_TABLE_BODY,
				rule: TabDisplayConfig.create({ transpose: true } as TabDisplayConfigOptions)
			}
		},
		'changesToHoldings.header': {
			default: {
				config: Config.FAMILY_CHANGES_TO_HOLDINGS_HEADER,
				rule: new TabDisplayConfig()
			}
		}

	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const FAMILY_PERFORMANCE_COMMENTARY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.performance.commentary',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true,
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'family.performance.commentary': {
			default: {
				config: Config.FAMILY_PERFORMANCE_COMMENTARY,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const FAMILY_PERFORMANCE_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.performance',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true,
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'performance': {
			default: {
				config: Config.PERFORMANCE,
				rule: new TabDisplayConfig()
			},
			[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF] })]: {
				config: Config.PERFORMANCE_PDF,
				rule: new TabDisplayConfig()
			}
		},
		'performance.benchmark': {
			default: {
				config: Config.PERFORMANCE_BENCHMARK,
				rule: new TabDisplayConfig()
			},
			[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF] })]: {
				config: Config.PERFORMANCE_BENCHMARK_PDF,
				rule: new TabDisplayConfig()
			}
		},
		'performance.custom.net': {
			default: {
				config: Config.PERFORMANCE_CUSTOM_NET,
				rule: new TabDisplayConfig()
			},
			[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF] })]: {
				config: Config.PERFORMANCE_CUSTOM_NET_PDF,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_PERFORMANCE_COLUMN_CONFIG]
});

const FAMILY_COMMENTARY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.commentary',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true,
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'family.commentary': {
			default: {
				config: Config.FAMILY_COMMENTARY,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

// TODO : Cleanup / kill fund prospectus
const FUND_PROSPECTUS_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.fund.prospectus',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'fund.prospectus': {
			default: {
				config: Config.FUND_PROSPECTUS,
				rule: TabDisplayConfig.create({
					transpose: true,
					conditions: [
						new FilterEmptyOrZeroColumnTransform(),
						new ConditionalTransformWrapper(new HasSpecificAssetClass('Cash'),
							new FilterSpecificAssetClassTransform('Cash'), null)
					]
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const EXCEL_HOLDINGS_MODEL_DATA: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me-excel-holdings-model-data',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'excel-blk-holdings-model-data': {
			default: {
				config: Config.EXCEL_BLK_HOLDINGS_MODEL_DATA,
				rule: new TabDisplayConfig()
			}
		},
		'excel-cms-holdings-model-data': {
			default: {
				config: Config.EXCEL_CMS_HOLDINGS_MODEL_DATA,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const EXCEL_HOLDINGS_DETAILS_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me-excel-holdings-details',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'excel-holdings-details': {
			default: {
				config: Config.EXCEL_HOLDINGS_DETAILS,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const EXCEL_HOLDINGS_DETAILS_CONFIG_AU: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me-excel-holdings-details-au',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'excel-holdings-details': {
			default: {
				config: Config.EXCEL_HOLDINGS_DETAILS_AU,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const FAMILY_LATEST_HOLDINGS_BODY_PDF_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.latest.holdings.body.pdf',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'latestHoldings': {
			default: {
				config: Config.FAMILY_LATEST_HOLDINGS_TABLE_BODY,
				rule: TabDisplayConfig.create({
					transpose: true,
					conditions: [new FilterEmptyOrZeroColumnTransform()]
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const FAMILY_LATEST_HOLDINGS_HEADER_PDF_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.latest.holdings.header.pdf',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'latestHoldings.header': {
			default: {
				config: Config.FAMILY_LATEST_HOLDINGS_HEADER,
				rule: TabDisplayConfig.create({ transpose: true } as TabDisplayConfigOptions)
			}
		},
		'holdingsTable.header.v2': {
			default: {
				config: Config.HOLDINGS_TABLE_HEADER_V2,
				rule: TabDisplayConfig.create({ transpose: true } as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

const FAMILY_CHANGES_TO_HOLDINGS_PDF_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.family.changesToHoldings.pdf',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'changesToHoldings': {
			default: {
				config: Config.FAMILY_CHANGES_TO_HOLDINGS_TABLE_BODY,
				rule: TabDisplayConfig.create({ transpose: true } as TabDisplayConfigOptions)
			}
		},
		'changesToHoldings.header': {
			default: {
				config: Config.FAMILY_CHANGES_TO_HOLDINGS_HEADER,
				rule: new TabDisplayConfig()
			}
		},
		'changesToHoldingsFlag': {
			default: {
				config: Config.FAMILY_CHANGES_TO_HOLDINGS_FLAG,
				rule: new TabDisplayConfig()
			}
		}

	},
	portfolioDataExtractor: [Config.FAMILY_COLUMN_CONFIG]
});

const PERFORMANCE_FUND_PDF_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.performance.fund.pdf',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		// this tab is not used but needed as the pdf components are built based on the order of the tabs, instead of the tab id
		'nav-monthly-pdf': {
			default: {
				config: Config.NAV_MONTHLY,
				rule: TabDisplayConfig.create({
					active: false,
					transpose: true
				} as TabDisplayConfigOptions)
			}
		},
		'std-nav-pdf': {
			default: {
				config: Config.STD_NAV_PDF,
				rule: TabDisplayConfig.create({
					active: false,
					transpose: true
				} as TabDisplayConfigOptions)
			}
		},
		'std-mkt-pdf': {
			default: {
				config: Config.STD_MKT_PDF,
				rule: TabDisplayConfig.create({
					active: false,
					transpose: true
				} as TabDisplayConfigOptions)
			}
		},
		'load-adj-returns-pdf': {
			default: {
				config: Config.LOAD_ADJ_RETURNS_PDF,
				rule: TabDisplayConfig.create({
					active: false,
					transpose: true
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.PORTFOLIO_NAME_COLUMN]
});

const PERFORMANCE_FEES_PDF_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.performance.fees.pdf',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'performance-fees-pdf': {
			default: {
				config: Config.PERFORMANCE_FEES_PDF,
				rule: TabDisplayConfig.create({
					transpose: true,
					conditions: [
						new ConditionalTransformWrapper(new HasAllDataMissingInAllPortfolios(), new HideTabTransform(), null)
					]
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.PORTFOLIO_NAME_COLUMN]
});

const PERFORMANCE_FUND_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.performance.fund',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'nav-monthly': {
			default: {
				config: Config.NAV_MONTHLY,
				rule: TabDisplayConfig.create({
					active: false,
					hideEmptyTab: true
				} as TabDisplayConfigOptions)
			}
		},
		'mkt-return-monthly': {
			default: {
				config: Config.MKT_RETURN_MONTHLY,
				rule: TabDisplayConfig.create({
					active: false,
					hideEmptyTab: true
				} as TabDisplayConfigOptions)
			}
		},
		'std-nav': {
			default: {
				config: Config.STD_NAV,
				rule: TabDisplayConfig.create({
					active: false,
					hideEmptyTab: true,
					conditions: [
						new ReplaceCellValueConditionTransform(new IsNotSpecificValue('FM'), '7_DAY_TRAILING_YIELD', '-', 'LEGAL_TYPE'),
						new ReplaceCellValueConditionTransform(new IsNotSpecificValue('FM'), 'UNSUBSIDIZED_7_DAY_SEC_YIELD', '-', 'LEGAL_TYPE')
					]
				} as TabDisplayConfigOptions)
			}
		},
		'std-mkt': {
			default: {
				config: Config.STD_MKT,
				rule: TabDisplayConfig.create({
					active: false,
					hideEmptyTab: true
				} as TabDisplayConfigOptions)
			}
		},
		'load-adj-returns': {
			default: {
				config: Config.LOAD_ADJ_RETURNS,
				rule: TabDisplayConfig.create({
					active: false,
					hideEmptyTab: true
				} as TabDisplayConfigOptions)
			}
		}
	},
	portfolioDataExtractor: [Config.PORTFOLIO_NAME_COLUMN]
});

const PERFORMANCE_FEES_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'performance.fees',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'performance-fees': {
			default: {
				config: Config.PERFORMANCE_FEES,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.PORTFOLIO_NAME_COLUMN]
});

const ESG_UPLIFT_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.esg.uplift',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true,
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'esgScore': {
			default: {
				config: Config.ESG_UPLIFT_SCORE,
				rule: new TabDisplayConfig()
			}
		},
		'categories': {
			default: {
				config: Config.ESG_UPLIFT_CATEGORIES,
				rule: new TabDisplayConfig()
			}
		},
		'asOfDate': {
			default: {
				config: Config.ESG_AS_OF_DATE,
				rule: new TabDisplayConfig()
			}
		}
	},
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

export const ESG_CARBON_INTENSITY_CONFIG: ComponentVisibility = ComponentVisibility.create({
	componentId: 'me.esg.carbon.intensity',
	visible: {
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.MODELS_EXPERIENCE], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true,
		[VisibilityConfigUtils.getTabConfigVisibilityKey({ view: [ViewCategory.FA_SELF_SERVICE_PDF], visibility: [VisibilityType.LOGGED_IN_VIEW] })]: true
	},
	tabs: {
		'esg.carbonIntensity': {
			default: {
				config: Config.ESG_CARBON_INTENSITY,
				rule: new TabDisplayConfig()
			}
		}
	},
	hideOnError: true,
	portfolioDataExtractor: [Config.FAMILY_HOLDING_COLUMN_CONFIG]
});

export const ME_VISIBILITY_CONFIG = {
	'me.families': FAMILIES_VISIBILITY_CONFIG,
	'me.models.overview': MODELS_OVERVIEW_VISIBILITY_CONFIG,
	'me.mini.compare': MODELS_MINI_COMPARE_VISIBILITY_CONFIG,
	'me.models.slider': MODELS_SLIDER_VISIBILITY_CONFIG,
	'me.dropdown.families': FAMILIES_LIST_CONFIG,
	'me.holdings.chart': HOLDING_CHART_CONFIG,
	'me.family.latestHoldings': FAMILY_LATEST_HOLDINGS_CONFIG,
	'me.family.changesToHoldings': FAMILY_CHANGES_TO_HOLDINGS_CONFIG,
	'me.family.performance.commentary': FAMILY_PERFORMANCE_COMMENTARY_CONFIG,
	'me.family.performance': FAMILY_PERFORMANCE_CONFIG,
	'me.family.commentary': FAMILY_COMMENTARY_CONFIG,
	'me-excel-holdings-model-data': EXCEL_HOLDINGS_MODEL_DATA,
	'me-excel-holdings-details': EXCEL_HOLDINGS_DETAILS_CONFIG,
	'me-excel-holdings-details-au': EXCEL_HOLDINGS_DETAILS_CONFIG_AU,
	'me.family.latest.holdings.body.pdf': FAMILY_LATEST_HOLDINGS_BODY_PDF_CONFIG,
	'me.family.latest.holdings.header.pdf': FAMILY_LATEST_HOLDINGS_HEADER_PDF_CONFIG,
	'me.family.changesToHoldings.pdf': FAMILY_CHANGES_TO_HOLDINGS_PDF_CONFIG,
	'me.performance.fund.pdf': PERFORMANCE_FUND_PDF_CONFIG,
	'me.performance.fees.pdf': PERFORMANCE_FEES_PDF_CONFIG,
	'me.performance.fund': PERFORMANCE_FUND_CONFIG,
	'me.performance.fees': PERFORMANCE_FEES_CONFIG,
	'me.esg.uplift': ESG_UPLIFT_CONFIG,
	'me.esg.carbon.intensity': ESG_CARBON_INTENSITY_CONFIG
};
